import styled from 'styled-components';
import ModalBodyContainer from '@sdk/components/ui/modal/ModalBodyContainer';

export const BodyContainer = styled(ModalBodyContainer)`
  width: 400px;
  padding: 10px 0 10px 10px;
  border: 1px solid ${({ theme }): string => theme.colors.separatorOnWhite};
  flex-direction: row;
  align-items: center;
  margin: 0;
`;
